"use client";
import {JSX} from "react";

import {DateUnavailableAlert} from "@/features/rental/check-availability/parts/date-unavailable-alert";

import {useTranslation} from "@/shared/i18n";

import "../styles/date-error-alert.scss";

interface Props {
    minNightsError?: boolean;
    minNightsErrorMessage?: string | null;
    dateUnavailableError?: boolean;
}

export function DateErrorAlert({minNightsError, minNightsErrorMessage, dateUnavailableError}: Props): JSX.Element | null {
    const {t} = useTranslation("rental");

    if (minNightsError && minNightsErrorMessage) {
        // minNightsErrorMessage is a translation key
        return <div className="date-error-alert date-error-alert--min-nights">{t(minNightsErrorMessage as Parameters<typeof t>[0])}</div>;
    }

    if (dateUnavailableError) {
        return <DateUnavailableAlert />;
    }

    return null;
}
